import allSettled from 'framework-asset-preview-lib/internal/shared/utils/allSettled';
import { getPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
import I18n from 'I18n';
import { fetchSmsPerformance } from './api';
import { AUTOMATED_SMS_STATE, BATCH_SMS_STATE, AUTOMATED_SMS_STATUS } from 'messaging-publishing-lib/constant/sms';
import { PROPERTIES } from 'messaging-publishing-lib/constant/sms';
export function getNonCrmPropertyValue(propertyName, nonCrmObject) {
  if (!nonCrmObject) {
    return undefined;
  }
  const smsResponse = nonCrmObject;
  if (propertyName in smsResponse.sms) {
    return smsResponse.sms[propertyName];
  }
  if (propertyName in smsResponse) {
    return smsResponse[propertyName];
  }
  return undefined;
}
export function isScheduledSms(smsCrmObject) {
  const smsState = getPropertyValue(smsCrmObject, PROPERTIES.SMS_STATE);
  return smsState === BATCH_SMS_STATE.SCHEDULED;
}
export function isProcessingSms(smsCrmObject) {
  const smsState = getPropertyValue(smsCrmObject, PROPERTIES.SMS_STATE);
  return smsState === BATCH_SMS_STATE.PROCESSING || smsState === BATCH_SMS_STATE.PRE_PROCESSING;
}
export function isSentSms(smsCrmObject) {
  const smsState = getPropertyValue(smsCrmObject, PROPERTIES.SMS_STATE);
  return smsState === BATCH_SMS_STATE.SENT;
}
export function isDraftSms(smsCrmObject) {
  const smsState = getPropertyValue(smsCrmObject, PROPERTIES.SMS_STATE);
  return smsState === BATCH_SMS_STATE.DRAFT || smsState === AUTOMATED_SMS_STATE.AUTOMATED_DRAFT;
}
export function isPublishedAutomatedSms(smsCrmObject) {
  const smsState = getPropertyValue(smsCrmObject, PROPERTIES.SMS_STATE);
  return smsState === AUTOMATED_SMS_STATUS.AUTOMATED;
}
export function isDraftAutomatedSms(smsCrmObject) {
  const smsState = getPropertyValue(smsCrmObject, PROPERTIES.SMS_STATE);
  return smsState === AUTOMATED_SMS_STATE.AUTOMATED_DRAFT;
}
export function getCounterValue({
  smsStatistics,
  statName
}) {
  if (!smsStatistics || !(statName in smsStatistics)) {
    return 0;
  }
  return smsStatistics[statName];
}
export function getRatioValue({
  smsStatistics,
  statName
}) {
  if (!smsStatistics || !(statName in smsStatistics)) {
    return 0;
  }
  return smsStatistics[statName] * 100;
}
export function getSmsPerformanceStats(crmObject) {
  const rooMicId = getPropertyValue(crmObject, 'hs_root_mic_id');
  const smsPerformancePromise = !rooMicId ? Promise.resolve(undefined) : fetchSmsPerformance(rooMicId);
  return allSettled([smsPerformancePromise]).then(promises => {
    const [smsStatisticsResponse] = promises;
    const smsStatistics = smsStatisticsResponse.status === 'fulfilled' ? smsStatisticsResponse.value : undefined;
    const overviewPerformanceGroup = {
      stats: [{
        formatStyle: 'decimal',
        propertyName: 'hs_total_delivered',
        value: getCounterValue({
          smsStatistics,
          statName: 'deliveries'
        })
      }, {
        formatStyle: 'decimal',
        propertyName: 'hs_total_send',
        value: getCounterValue({
          smsStatistics,
          statName: 'sends'
        })
      }, {
        formatStyle: 'decimal',
        propertyName: 'hs_total_click',
        value: getCounterValue({
          smsStatistics,
          statName: 'totalClicks'
        })
      }, {
        formatStyle: 'decimal',
        propertyName: 'hs_unique_click',
        value: getCounterValue({
          smsStatistics,
          statName: 'uniqueClicks'
        })
      }, {
        formatStyle: 'percentage',
        propertyName: 'hs_click_rate',
        value: getRatioValue({
          smsStatistics,
          statName: 'clickRate'
        })
      }],
      title: I18n.text('frameworkAssetPreviewLib.tabs.performance.performanceGroup.0-124.overview')
    };
    const deliveryPerformanceGroup = {
      stats: [{
        formatStyle: 'decimal',
        propertyName: 'hs_failed_send',
        value: getCounterValue({
          smsStatistics,
          statName: 'failedSends'
        })
      }, {
        formatStyle: 'decimal',
        propertyName: 'hs_failed_delivered',
        value: getCounterValue({
          smsStatistics,
          statName: 'failedDeliveries'
        })
      }, {
        formatStyle: 'percentage',
        propertyName: 'hs_delivery_rate',
        value: getRatioValue({
          smsStatistics,
          statName: 'deliveryRate'
        })
      }],
      title: I18n.text('frameworkAssetPreviewLib.tabs.performance.performanceGroup.0-124.delivery')
    };
    return [overviewPerformanceGroup, deliveryPerformanceGroup];
  });
}